import { defaultNextHiddenProviderIndex, maxNumberOfProvidersToShow } from './constants'
import { FeedbackType, ProviderLevelFeedbackSavePayload } from './types'

export const generateProviderLevelFeedbackSavePayload = ({
  userId,
  providerId,
  searchId,
  requestId,
  feedbackType,
  wordChips = [],
  freeTextFeedback = '',
}: {
  userId: string
  providerId: string
  searchId: string
  requestId: string
  feedbackType: FeedbackType
  wordChips: string[]
  freeTextFeedback: string
}): ProviderLevelFeedbackSavePayload => {
  const wordChipsString = wordChips?.join(';').toLowerCase()
  const trimmedFreeTextFeedback = freeTextFeedback.trim()

  return {
    userLyraId: userId,
    providerLyraId: providerId,
    searchId,
    requestId,
    feedbackType,
    wordChips: wordChipsString,
    freeTextFeedback: trimmedFreeTextFeedback,
  }
}

export const getInitialNextHiddenProviderIndex = ({ totalNumberOfProviders }: { totalNumberOfProviders: number }) => {
  return totalNumberOfProviders > maxNumberOfProvidersToShow
    ? maxNumberOfProvidersToShow
    : defaultNextHiddenProviderIndex
}
